import React, { Fragment } from "react";
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { notificationConstants, notificationValidations } from "./notificationConstant";
import FormInput from "../Common/FormInputs/MuiTextField";
import AppCheckbox from "../Common/FormInputs/AppCheckbox";

const messageControlSx = {
    flex: "0 1 auto",
    minWidth: 0,
    minHeight: 0,
    maxWidth: 280,
};
const fieldRowSx = {
    display: "grid",
    gridTemplateColumns: { xs: "1fr", md: "200px minmax(0, 280px)" },
    alignItems: "center",
    gap: 1.5,
    marginBottom: 2,
    "&:last-of-type": { marginBottom: 0 },
};
const sectionCardSx = {
    p: 2,
    mt: 1.5,
    boxShadow: 2,
    borderRadius: 1,
};

const PushNotification = ({
    allowedDeviceCategories,
    allowedCompanyBrand,
    setAlert,
    pnMessage,
    handleMessageData,
    pnPlatforms,
    handlePlatformChange
}) => {
    return (
        <Fragment>
            <Typography variant="subtitle1" fontWeight={600} sx={{ mt: 2 }}>
              Message
            </Typography>
            <Paper sx={sectionCardSx}>
                <Box sx={fieldRowSx}>
                    <Typography variant="body2" fontWeight={600}>Select Platforms:</Typography>
                    <Box>
                        <FormControl component="fieldset">
                            <FormGroup>
                                <AppCheckbox
                                    checked={pnPlatforms['iosPlatform']}
                                    onChange={(e) => {
                                        handlePlatformChange(e.target.name, e.target.checked)
                                    }}
                                    name={notificationConstants.iosPlatform}
                                    color="default"
                                    label="iOS"
                                    sx={{ ml: "-11px" }}
                                />
                                <AppCheckbox
                                    checked={pnPlatforms['androidPlatform']}
                                    onChange={(e) => {
                                        handlePlatformChange(e.target.name, e.target.checked)
                                    }}
                                    name={notificationConstants.androidPlatform}
                                    color="default"
                                    label="Android"
                                    sx={{ ml: "-11px" }}
                                />
                            </FormGroup>
                        </FormControl>
                    </Box>
                </Box>
                <Box sx={fieldRowSx}>
                    <Typography variant="body2" fontWeight={600}>Message:</Typography>
                    <Box sx={messageControlSx}>
                        <FormInput
                            type="textarea"
                            rows={2}
                            placeholder="Write a Message"
                            value={pnMessage}
                            onChange={(e) => {
                                handleMessageData((e.target.value).substring(0, notificationValidations?.push?.body?.maxLength))
                            }}
                            sx={{ 
                                maxWidth: 280,
                                "& .MuiInputBase-root": {
                                    alignItems: "flex-start",
                                },
                                "& .MuiInputBase-input": {
                                    verticalAlign: "top !important",
                                    paddingTop: "8.5px !important",
                                }
                            }}
                        />
                        <Typography variant="caption" sx={{ display: "block", mt: 0.5 }}>
                            {(pnMessage?.length > notificationValidations?.push?.body?.maxLength
                              ? notificationValidations?.push?.body?.maxLength
                              : pnMessage?.length) + "/" + notificationValidations?.push?.body?.maxLength}
                        </Typography>
                    </Box>
                </Box>
            </Paper>
        </Fragment>
    );
}


export default PushNotification